import { FormattedMessage, useIntl } from 'react-intl';
import { getContextId } from '@tlx/astro-shared';
import { AddIcon, PersonIllustration } from '@tlx/atlas';
import { TableEmptyState } from '@Component/Table/Table.utils.tsx';

export function TableEmptyCreateEmployee() {
    const { formatMessage } = useIntl();
    return (
        <TableEmptyState
            illustration={<PersonIllustration size={'small'} />}
            onClickAction={() => window.open(`/execute/employeeMenu?employeeId=0&contextId=${getContextId()}`, '_self')}
            titleMessage={formatMessage({
                id: 'tsk_filter_results_empty_create_employee',
            })}
            descriptionMessage={formatMessage({
                id: 'tsk_filter_results_empty_create_employee_description',
            })}
            buttonContent={
                <span className="atl-flex atl-gap-8 atl-items-center">
                    <FormattedMessage id="heading_new_employee" />
                    <AddIcon />
                </span>
            }
        />
    );
}

export function NewTableEmptyCreateEmployee() {
    const intl = useIntl();

    return (
        <TableEmptyState
            titleMessage={intl.formatMessage({
                id: 'tsk_filter_results_empty_create_employee',
            })}
            descriptionMessage={intl.formatMessage({
                id: 'tsk_filter_results_empty_create_employee',
            })}
            buttonContent={intl.formatMessage({
                id: 'heading_new_employee',
            })}
            illustration={<PersonIllustration size={'small'} />}
            onClickAction={() => {
                window.open(`/execute/employeeMenu?employeeId=0&contextId=${getContextId()}`, '_self');
            }}
        />
    );
}
